import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

/**
 * Data attribution and the prototype notice.
 *
 * The attribution is deliberately prominent rather than a legal afterthought:
 * every dataset in this application is published by the Oklahoma Office of
 * Geographic Information, and the application's whole argument is that those
 * public services are a valuable asset. Crediting them is the point, not a
 * footnote.
 *
 * The prototype notice stays until there is a written agreement. This is not an
 * official State of Oklahoma application and must never be mistaken for one.
 */
export default function AttributionBar() {
  return (
    <Box
      component="footer"
      sx={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        px: 1.5,
        py: 0.5,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1.5,
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        opacity: 0.96,
        pointerEvents: 'auto',
      }}
    >
      <Typography variant="caption" color="text.secondary">
        Data published by the{' '}
        <Link
          href="https://okmaps.org/OGI/"
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
        >
          Oklahoma Office of Geographic Information
        </Link>{' '}
        via public OGC services. Basemap &copy; OpenStreetMap contributors.
      </Typography>

      <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
        Unofficial prototype. Not affiliated with the State of Oklahoma.
      </Typography>
    </Box>
  );
}
